import { render } from "./ErrorNotification.vue?vue&type=template&id=79f62ed1&scoped=true&ts=true"
import script from "./ErrorNotification.vue?vue&type=script&lang=ts"
export * from "./ErrorNotification.vue?vue&type=script&lang=ts"

import "./ErrorNotification.vue?vue&type=style&index=0&id=79f62ed1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f62ed1"]])

export default __exports__